import React from "react";
import { Link } from "react-router-dom";

const ShippingDelivery = () => {



  return (
    <main>
      {/* breadcrumb start */}
      <section
        className="page-title mt-[80px]"
        style={{ backgroundImage: "url(assets/images/inner/page-title-bg.jpg)" }}
      >
        <div className="auto-container">
          <div className="title-outer">
            <ul className="page-breadcrumb wow fadeInUp" data-wow-delay=".3s">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>Shipping & Delivery Policy</li>
            </ul>
            <h1 className="title wow fadeInUp" data-wow-delay=".5s">
              Shipping & Delivery Policy
            </h1>
          </div>
        </div>
      </section>
      {/* breadcrumb end */}

      {/* shipping start  */}
      <section class="about-section fix section-padding">
        <div class="auto-container">
          <div class="row g-4">
            <div class="col-lg-12">
              <ul>
                <li className="mb-2">
                  1. Service orders are fulfilled by our empaneled health
                  providers through their qualified technicians or
                  phlebotomist or staff.
                </li>
                <li className="mb-2">
                  2. Product orders are shipped through registered domestic
                  courier companies and /or speed post only.
                </li>
                <li className="mb-2">
                  3. Orders are shipped within 0-7 days or as per the delivery
                  date agreed at the time of order confirmation and delivering
                  of the shipment subject to Courier Company / post office
                  norms.
                </li>
                <li className="mb-2">
                  4. We are not liable for
                  any delay in delivery by the courier company / postal
                  authorities and only guarantees to hand over the consignment
                  to the courier company or postal authorities within 0-7 days
                  rom the date of the order and payment or as per the delivery
                  date agreed at the time of order confirmation.
                </li>
                <li className="mb-2">
                  5. Delivery of all orders will be to the address provided by
                  the buyer.
                </li>
                <li className="mb-2">
                  6. Delivery of our services will be confirmed on your mail
                  ID as specified during registration. For any issues in
                  utilizing our services you may contact our helpdesk on <br/>
                  <a href="tel:917303047811" style={{ display: "inline" }}>
                    +91-730-304-7811
                  </a>
                  <span style={{ margin: "0px 2px" }}>or</span>
                  <a
                    href="mailto:"
                    style={{ display: "inline" }}
                  >
                    admin@zealthix.com
                  </a>

                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      {/* shipping end  */}


    </main>
  );
};

export default ShippingDelivery;
